import { connect, ConnectedProps } from "react-redux";

import { FareClassOptionSelection } from "./component";
import { getFareclassOptionFilter } from "../../../../../search/reducer/selectors";
import { actions } from "../../../../../search/actions";
import { flightShopTypeSelector } from "../../../../../shop/reducer/selectors";
import { disruptionProtectionOriginalSliceFareRatingSelector } from "../../../../../ancillary/reducer/selectors";

import { IStoreState } from "../../../../../../reducers/types";
import { isInDisruptionProtectionRebookSelector } from "../../../../reducer/selectors";
import { setRerunPrediction } from "../../../../actions/actions";

const mapStateToProps = (state: IStoreState) => ({
  flightShopType: flightShopTypeSelector(state),
  disruptionProtectionOriginalSliceFareRating:
    disruptionProtectionOriginalSliceFareRatingSelector(state),
  fareClassOptionFilter: getFareclassOptionFilter(state),
  isInDisruptionProtectionRebook: isInDisruptionProtectionRebookSelector(state),
});

const mapDispatchToProps = {
  setFareClassOptions: actions.setFareclassOptionFilter,
  setRerunPrediction: setRerunPrediction,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type FareClassOptionSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedFareClassOptionSelection = connector(
  FareClassOptionSelection
);
